import { types as passengerTypes } from 'types/passengers';
import { sortLegsByDate } from 'utils/sortLegsByDate';
import { pathOr, pluck, uniq, flatten } from 'ramda';
import productTypes from 'constants/productTypes';

export const findEarliest = (legs) => {
  if (legs && legs.length <= 0) {
    return null;
  }

  const [{ timing }] = [...legs].sort(sortLegsByDate);

  return timing.date;
};

export const findEarliestLeg = (legs) => {
  if (legs && legs.length <= 0) {
    return null;
  }

  return [...legs].sort(sortLegsByDate)[0];
};

export const getNoOfPassengerTypes = (types, booking, selectedItems) =>
  booking?.passengers
    ?.filter((p) => types.includes(p.type))
    .filter((p) =>
      booking.allBookingItems
        .filter((bi) => selectedItems.includes(bi.itemRef))
        .map((bi) => bi.passengerId)
        .includes(p.id)
    ).length;

export const hasEnoughPoints = (points, customerInfo) => points <= customerInfo?.profile?.loyalty?.rewardPoints;

export const buildUpgradeSearchPassengers = (booking, selectedItems) =>
  booking?.passengers
    ?.filter((p) =>
      booking.allBookingItems
        .filter((bi) => selectedItems.includes(bi.itemRef))
        .map((bi) => bi.passengerId)
        .includes(p.id)
    )
    .map((p) => ({
      id: p.id,
      type: p.type,
      disabilityType: p.disabilityType || passengerTypes.NO_HANDICAP
    }));

const getProducts = pathOr([], ['products']);

const allowedRebookExtrasTypes = [productTypes.BIKES, productTypes.LUGGAGE, productTypes.CHAMPAIGN, productTypes.EXTERNAL_TICKET];

export const getExtrasVariables = (selectedFare, extras) => {
  const segments = selectedFare.legs.map((l) => ({
    direction: selectedFare.direction,
    origin: l.origin.uic,
    destination: l.destination.uic,
    serviceName: l.serviceName,
    startValidityDate: l.timing.departureDate,
    startValidityTime: l.timing.departs,
    serviceIdentifier: l.serviceIdentifier
  }));

  const products = flatten(selectedFare.legs.map((leg) => getProducts(leg)));
  const uniquePassengerIds = uniq(pluck('passengerId', products).filter(Boolean));
  const selectedExtrasToExchange = flatten(
    uniquePassengerIds?.map((uniquePassengerId) => extras?.filter((s) => s.passengerId === uniquePassengerId))
  );

  const passengers = selectedExtrasToExchange.map((selectedExtra) => ({
    id: selectedExtra.passengerId,
    type: selectedExtra.passenger.type,
    disabilityType: selectedExtra.passenger.disabilityType
  }));

  const types = uniq(selectedExtrasToExchange.map((selectedExtra) => selectedExtra.type))?.filter((po) =>
    allowedRebookExtrasTypes.includes(po)
  );

  return {
    segments,
    passengers,
    isAftersales: true,
    types
  };
};

export const rebookExtrasRequest = (extrasAvailability, extras) => {
  const extrasTariffs = extrasAvailability?.extras?.map((extraAvailability) => extraAvailability.id)?.flat();

  return extras
    ?.filter((extra) => extrasTariffs?.includes(extra.tariffDetails.tariffCode))
    .map((extra) => ({
      passengerId: extra.passengerId,
      price: extra.price,
      tariffCode: extra.tariffDetails.tariffCode
    }));
};
